
import { computed, defineComponent, ComputedRef } from 'vue';
import authStore from '@/shared/auth/auth.store';

export default defineComponent({
    name: 'ToggleNetPrice',
    setup() {
        const iconName: ComputedRef<string> = computed(() => {
            return authStore.showNetPrice ? 'icon-eye' : 'icon-eye-line';
        });

        const toggleNetPrice = (event: Event): void => {
            event.preventDefault();
            event.stopPropagation();
            authStore.toggleNetPrice();
        };

        return {
            iconName,
            toggleNetPrice,
        };
    },
});
